import { Suspense } from 'react'
import { Switch } from 'react-router-dom'
import { BaseLayout } from '../../components/layout/BaseLayout'
import { FallbackLoader } from '../../components/layout/FallbackLoader'
import { useAuth } from '../../context/Auth'
import { budgetcalculationpage } from './budgetcalculationpage'
import { budgetdashboardpage } from './budgetdashboardpage'
import { budgetdivisioncostspage } from './budgetdivisioncostspage'
import { budgetdivisionscalendarpage } from './budgetdivisionscalendarpage'
import { budgetdivisionpage } from './budgetdivisionspage'
import { budgetenergycostspage } from './budgetenergycostspage'
import { budgetfixedcostspage } from './budgetfixedcostspage'
import { budgetindirectmaterialpage } from './budgetindirectmaterialpage'
import { budgetitemsimportpage } from './budgetitemsimportpage'
import { budgetlistinipage } from './budgetlistinipage'
import { budgetpage } from './budgetpage'
import { budgetproductionconsumptionspage } from './budgetproductionconsumptionspage'
import { budgetproductionneedspage } from './budgetproductionneedspage'
import { budgetproductionvolumespage } from './budgetproductionvolumespage'
import { budgetresultsarticlepricelist } from './budgetresultsarticlepricelist'
import { budgetsummarypage } from './budgetsummarypage'
import { homepage } from './homepage'
import { login } from './login'
import { noMatch } from './noMatch'
import { stoptemplatespage } from './stoptemplatespages'

const commonRoutes: JSX.Element[] = []

// NOTE: it's mandatory that the noMatch route must be the last one
const publicRoutesConfiguration: JSX.Element[] = login.concat(commonRoutes).concat(noMatch)
const privateRoutesConfiguration: JSX.Element[] = login
  .concat(budgetpage)
  .concat(budgetdashboardpage)
  .concat(budgetdivisionpage)
  .concat(budgetitemsimportpage)
  .concat(budgetindirectmaterialpage)
  .concat(budgetdivisionscalendarpage)
  .concat(budgetfixedcostspage)
  .concat(budgetdivisioncostspage)
  .concat(budgetenergycostspage)
  .concat(budgetproductionneedspage)
  .concat(budgetproductionvolumespage)
  .concat(budgetproductionconsumptionspage)
  .concat(budgetcalculationpage)
  .concat(budgetsummarypage)
  .concat(budgetlistinipage)
  .concat(homepage)
  .concat(stoptemplatespage)
  .concat(budgetresultsarticlepricelist)
  .concat(commonRoutes)
  .concat(noMatch)

export const Routes = () => {
  const {
    state: { authorized },
  } = useAuth()

  if (!authorized) {
    return (
      <Suspense fallback={<FallbackLoader />}>
        <Switch>{publicRoutesConfiguration}</Switch>
      </Suspense>
    )
  }
  return (
    <BaseLayout>
      <Suspense fallback={<FallbackLoader />}>
        <Switch>{privateRoutesConfiguration}</Switch>
      </Suspense>
    </BaseLayout>
  )
}
